import { LOGIN_START } from '../login/login.action-types';
import { authenticateComplete, loginError } from '../login/login.actions';
import { sanitizeRetailerId } from '@common/utils';
const {
  Authenticate
} = svs.retail;
const {
  Events
} = Authenticate;
const authenticateConnector = store => {
  const onAuthenticateError = options => {
    store.dispatch(loginError(options));
  };
  const onAuthenticateSuccess = ({
    mustChangePassword
  }) => {
    store.dispatch(authenticateComplete({
      mustChangePassword
    }));
  };
  const events = {
    [Events.AUTHENTICATE_ERROR]: onAuthenticateError,
    [Events.AUTHENTICATE]: onAuthenticateSuccess
  };
  Authenticate.on(events, this);
  return next => action => {
    if (!store.getState()?.login?.isLoading && action.type === LOGIN_START) {
      const iamParams = store.getState()?.login?.iamParams;
      const isIamMode = Boolean(iamParams?.redirectUri && iamParams?.state);
      if (isIamMode && typeof document !== 'undefined') {
        const sanitizedRetailerId = sanitizeRetailerId(action.retailerId);
        if (sanitizedRetailerId) {
          document.cookie = `iam_retailer_id=${sanitizedRetailerId}; Max-Age=300; Path=/; SameSite=Lax`;
        }
      }
      Authenticate.login({
        retailerId: action.retailerId,
        username: action.username,
        password: action.password,
        nonce: isIamMode ? iamParams?.nonce : undefined,
        clientId: isIamMode ? iamParams?.clientId : undefined,
        state: isIamMode ? iamParams?.state : undefined,
        redirectUri: isIamMode ? iamParams?.redirectUri : undefined
      });
    }
    return next(action);
  };
};
export { authenticateConnector };